import { useGetAllCountriesQuery } from '@/features/DataChangeRequest/_graphql/query/GetAllCountries.hook';
import { useGetAllPicklistsQuery } from '@/features/DataChangeRequest/_graphql/query/GetAllPicklists.hook';
import { useGetDcrSetupQuery } from '@/features/DataChangeRequest/_graphql/query/GetDCRSetup.hook';
import { useGetPreferredCountryQuery } from '@/features/DataChangeRequest/_graphql/query/GetPreferredCountry.hook';

export const usePrefetchDcrModalData = () => {
	const { data: preferredCountryData } = useGetPreferredCountryQuery();
	useGetAllCountriesQuery();

	const preferredCountryId =
		preferredCountryData?.preferredCountryDcrs.__typename === 'DCRResults'
			? preferredCountryData.preferredCountryDcrs.results[0]?.country?.id
			: undefined;

	useGetAllPicklistsQuery({
		skip: !preferredCountryId,
		variables: preferredCountryId
			? { countryId: preferredCountryId }
			: undefined
	});
	useGetDcrSetupQuery({
		skip: !preferredCountryId,
		variables: { countryId: preferredCountryId ?? '' }
	});
};
